import { FC } from 'react'
import { componentProvider } from '@/components/component-provider'
import HeaderImage, { Overlay } from '@/components/elements/header-image'
import EntryContent from '@/components/entry-content'
import { ApplyButton, PageProps } from '@/types/site.interface'
import Text from '@ignition/library/components/atoms/text'
import { formatDate } from '@ignition/library/utils/format-date'

const styles = {
  dateContainer: 'grid-flow-col-dense justify-between grid max-w-2xl text-center mx-10 xl:mx-auto',
  textDate: 'mt-3 text-xs md:text-base sm:mt-4 place-self-center',
}

interface JobPageProps extends PageProps {
  overlay: Overlay
  validThrough: string
  applyButton: ApplyButton
}

interface JobPageTypeProps {
  page: JobPageProps
}

const JobPage: FC<JobPageTypeProps> = ({ page }) => {
  const { applyButton, image, title, summary, content, overlay, validThrough } = page
  const valid = formatDate(validThrough, 'MMMM dd, yyyy')
  return (
    <div>
      <HeaderImage applyButton={applyButton} image={image} title={title} summary={summary} overlay={overlay} />
      <div className={styles.dateContainer}>
        {valid && (
          <Text as="span" className={styles.textDate}>
            Gültig bis {valid}
          </Text>
        )}
      </div>
      <EntryContent elements={content} componentProvider={componentProvider} />
    </div>
  )
}
export default JobPage
